import React from "react";
import type { Company } from "../../../types";

const SIZE_CLASS = { sm: "h-7 w-7 min-h-[1.75rem] min-w-[1.75rem]", md: "h-9 w-9 min-h-9 min-w-9" };

/** Miniatura da logo (ou inicial do nome) para navbar e listas. */
export function CompanyLogoThumb({
  company,
  size = "sm",
}: {
  company: Pick<Company, "logo" | "name">;
  size?: "sm" | "md";
}) {
  const src = company.logo?.trim();
  const box = SIZE_CLASS[size];
  const initial = (company.name?.trim()?.[0] ?? "?").toUpperCase();
  if (!src) {
    return (
      <span
        className={`${box} shrink-0 rounded-lg bg-[#4B5563] text-[11px] font-bold text-gray-200 flex items-center justify-center`}
        aria-hidden
      >
        {initial}
      </span>
    );
  }
  return (
    <img
      src={src}
      alt=""
      className={`${box} shrink-0 rounded-lg object-cover border border-[#374151] bg-[#2D3748]`}
    />
  );
}
